type monthlyMultipliers = {
    month: Month,
    multiplier: number
}

export type GetIdealMultipliersResponse = {
    multiplier: number,
    monthlyMultipliers: monthlyMultipliers[],
}

export enum Month
{
    January,
    February,
    March,
    April,
    May,
    June,
    July,
    August,
    September,
    October,
    November,
    December,
}